require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-bootstrap/~/babel-runtime/~/core-js/library/fn/object/assign.js
 ** module id = 748
 ** module chunks = 0
 **/